import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { forgotPasswordAction } from "@/features/auth/services/authService";
import { Button } from "@/shared/components/ui/Button";
import { Input } from "@/shared/components/ui/Input";

export const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await forgotPasswordAction(email);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 md:p-8">
      <h1 className="text-xl md:text-2xl font-bold text-center mb-2">{t("auth.forgot_password_title")}</h1>
      <p className="text-sm text-gray-500 text-center mb-6">{t("auth.forgot_password_subtitle")}</p>

      {success ? (
        <div className="text-center">
          <p className="text-green-600 mb-4">A temporary password has been sent to your email.</p>
          <Link to="/login" className="text-indigo-600 hover:text-indigo-700">{t("auth.back_to_login")}</Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input label={t("auth.email_label")} type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" loading={loading} className="w-full">{t("auth.send_temp_pass")}</Button>
        </form>
      )}

      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="text-indigo-600 hover:text-indigo-700">{t("auth.back_to_login")}</Link>
      </p>
    </div>
  );
};
